export default function CheckBoxGroup({ id, options, isSelected, getSelected, setSelected }) {

  const getLabel = (option) =>
    option.abbrLabel && "" !== option.abbrLabel
      ? option.abbrLabel
      : option.label;

  const changeHandler = (event) => {
    const { name, value, checked } = event.target;
    const currVal = getSelected(name)
    const newVal = checked
      ? currVal.concat(value)
      : currVal.filter((e) => e !== value);
    // console.log(`${currVal}, ${value} ${checked} => ${newVal}`);
    setSelected(name, newVal);
  };

  return (
    <ul className="checkbox-group-options">
      {options.map((opt) => (
        <li key={opt.id} className="prompt-option">
          <label>
            <input
              type="checkbox"
              className="prompt-checkbox"
              name={id}
              value={opt.id}
              checked={isSelected(id, opt.id)}
              onChange={changeHandler}
            />
            {getLabel(opt)}
          </label>
        </li>
      ))}
    </ul>
  );
}